<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-01-12 08:59:01
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-09-13 18:13:09
 * @FilePath: \vue-hepha-order\src\views\financial\FinancialReceipts.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div id="modalContainer">
        <a-tabs :active-key="activeKey" @change="tabClick">
            <a-tab-pane key="1" :title="$t('financial.overdueList')"></a-tab-pane>
            <a-tab-pane key="2" :title="$t('financial.SEPACollection')"></a-tab-pane>
        </a-tabs>

        
        <OverdueList v-if="activeKey == 1"></OverdueList>
        <SEPACollection v-if="activeKey == 2"></SEPACollection>

        <!-- 更新订单状态 -->
        <!-- <a-modal
            v-model:visible="visible" 
            width="600px"
            draggable
            popup-container="#modalContainer"
            :onBeforeOk="onBeforeOk"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <template #title>
                <div style="font-weight:bold">{{ title }}</div> 
            </template>
            
            <a-select :style="{width:'320px'}" v-model="order_status" v-if="modalType == 'updateStatus'">
                <a-option value='7'>{{ $t('order.obligation') }}</a-option>
                <a-option value='0'>{{ $t('order.partialPay') }}</a-option>
                <a-option value='1'>{{ $t('order.pay') }}</a-option>
            </a-select>

            <a-date-picker v-else style="width: 200px;" v-model="pay_timestamp "/>
        </a-modal> -->
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import OverdueList from './OverdueList.vue';
    import SEPACollection from './SEPACollection.vue';
    import { FinancialQuery } from './queryConfig/FinancialQuery.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';

    const localeStore = useLocale()
    const { t } = useI18n()

    const activeKey = ref('1')
    const sourceObj = ref({})



    const tabClick = (val)=>{
        activeKey.value = val
    }

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
/deep/ .arco-tabs-nav-tab{
    background:#fff;
    padding-left: 8px;
}
/deep/ .arco-tabs-content{
    padding-top:6px;
}

</style>